var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5_4",
    transform: "scale(0.0333333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5_4",
    width: 30,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAABZElEQVRIie2Wv0rDUBTGv1scKxQLuoibm6Mu/kGrQylSfIG+g5OUbn0irfUhRKigVDe3dnArCk4iP4ceIY03sWmuLvWDEM7J4fvl3JPcRPrX3Ak4BoaE0wCoxTnOAx5IWg3cz8A5t5Za8XWboYhJfoVQgKyaP/BC0oWQc/Zp/pY6C3hH0l6OeGZwQZMbTtZ4Qr6d61ceKufcBOvPZgyUpwXnmqFHj0B9GvCsM+xIOpBUtKMi6VLSiqRzoOql5fwEnkV8boDrSNy0mhFQCgm+8PnEcl1Lt9LA28Buhnh/CnDF0nchZ3zrMwGWI2HPzutpHWdVMebTt3wfe5WARcu9+DoeJi3BD9qMxUeSHiRtSGpYbsvOT76Oa4x/0LKq4/EqA6fAksVXVtuesblv5s9m2Eypa1nNiNgulgdeB97NuMv46S3acRjp9AM4CQKNwKvWTZJGwaEReMmW9B54A16BHtCOL+8nJBinYzcmssIAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalender);
export default __webpack_public_path__ + "static/media/icon__calender.3695d38163e2ee6e4e3e9985960e948a.svg";
export { ForwardRef as ReactComponent };